import { IGroup } from '@fluentui/react';
import { matchItemListToGroupList } from './matchItemListToGroupList';
import { applyGroupCollapseBehavior } from './applyGroupCollapseBehavior';
import { applyGroupNamesToGroupList } from './applyGroupNames';
import { GroupByOption } from 'component/Search/types';

/**
 * This function takes in a list of items and groups them based on the
 * content from a provided external data source. It also applies the group
 * collapse behavior.
 */
export const groupByExternalDataSource = <T,>(
  itemList: T[],
  groupData: IGroup[],
  groupByOption: GroupByOption,
  isAllGroupsCollapsed: boolean,
  collapsedGroups: any[]
) => {
  const groupListWithIndex = matchItemListToGroupList(
    itemList,
    groupData,
    groupByOption
  );

  const groupListWithCollapse = applyGroupCollapseBehavior(
    groupListWithIndex,
    isAllGroupsCollapsed,
    collapsedGroups
  );

  const groupListWithName = applyGroupNamesToGroupList(
    groupListWithCollapse,
    groupByOption
  );

  return groupListWithName;
};
